export enum AnswerTypes {
  RADIO,
}
